import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-2xl mx-auto text-center" data-id="element-85">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="flex flex-col items-center" data-id="element-86">
        <ShieldCheck className="w-16 h-16 text-amber-500 mb-6" data-id="element-87" />

        <h2 className="text-3xl font-heading font-bold text-white mb-6 uppercase tracking-wide" data-id="element-88">
          🛡️ GARANTÍA 7 DÍAS
        </h2>

        <div className="space-y-4 text-lg text-zinc-300" data-id="element-89">
          <p className="font-bold text-white text-xl" data-id="element-90">Probalo.</p>
          <p data-id="element-91">
            Si no sentís más orden, más control y menos presión en tu agenda…
          </p>
          <p className="font-bold text-amber-400" data-id="element-92">Te devolvemos la plata.</p>
          <p className="uppercase tracking-widest text-sm text-zinc-500 font-bold pt-4" data-id="element-93">
            Sin vueltas.
          </p>
        </div>
      </motion.div>
    </section>;
}